import { ReactNode, useEffect } from 'react'
import { LeaguestarState } from '../state'
import AuthLayout from '../auth/AuthLayout'
import { ReactComponent as LeaguestarLogo } from '../assets/leaguestar_logo.svg'
import PlatformPicker, { Platform } from './PlatformPicker'
import authClasses from '../auth/Auth.module.css'

const STORAGE_KEY = 'leaguestar_selected_platform'

interface Props {
  platforms: Platform[]
  children: ReactNode
}

export default function PlatformPickerGate({ platforms, children }: Props) {
  const selectedPlatformId = LeaguestarState.useState(
    (s) => s.selected_platform_id
  )

  // On mount, restore from localStorage or auto-select if single platform
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const storedId = Number(stored)
      const isValid = platforms.some((p) => p.platform_id === storedId)
      if (isValid) {
        LeaguestarState.update((s) => {
          s.selected_platform_id = storedId
        })
        return
      }
      localStorage.removeItem(STORAGE_KEY)
    }

    // Auto-select if only one platform
    if (platforms.length === 1) {
      const id = platforms[0].platform_id
      LeaguestarState.update((s) => {
        s.selected_platform_id = id
      })
      localStorage.setItem(STORAGE_KEY, String(id))
    }
  }, [platforms])

  const handleSelect = (platformId: number) => {
    LeaguestarState.update((s) => {
      s.selected_platform_id = platformId
    })
    localStorage.setItem(STORAGE_KEY, String(platformId))
  }

  // Show picker if multiple platforms and none selected
  if (platforms.length > 1 && !selectedPlatformId) {
    return (
      <AuthLayout>
        <div className={authClasses.auth_container}>
          <div className={authClasses.auth_wrapper}>
            <LeaguestarLogo className={authClasses.leaguestar_logo} />
            <PlatformPicker platforms={platforms} onSelect={handleSelect} />
          </div>
        </div>
      </AuthLayout>
    )
  }

  return <>{children}</>
}
